<template>
  <div class="zoom-wrapper">
    <el-tooltip content="Zoom out" placement="bottom" class="zoom-control">
      <span :class="['zoom_out', 'zoom', zoomCursor('out')]" @click="zoomOut">
        <img :src="zoomIcon('out')" />
      </span>
    </el-tooltip>

    <span class="zoom-percent">{{ zoomPercent }}</span>

    <el-tooltip content="Zoom in" placement="bottom" class="zoom-control">
      <span :class="['zoom_in', 'zoom', zoomCursor('in')]" @click="zoomIn">
        <img :src="zoomIcon('in')" />
      </span>
    </el-tooltip>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from 'vuex';
import { zoom } from '@/utils/constants';

export default {
  computed: {
    ...mapState('material', ['pdfZoom', 'htmlZoom', 'showPDFHtml', 'pdfHtmlZoom']),
    ...mapGetters(['isDiscoveryLesson', 'isTrainer']),
    ...mapGetters('htmlMaterial', { isHtmlTrainer: 'isTrainer' }),

    // True on the standalone trainer HTML route (matched by name, safe if $route is absent).
    isTrainerHtmlRoute() {
      return this.$route && this.$route.name === 'TrainerHtmlMaterial';
    },

    // Trainer if root isTrainer, htmlMaterial.userType === 't', or on the trainer HTML route.
    isTrainerContext() {
      return this.isTrainer || this.isHtmlTrainer || this.isTrainerHtmlRoute;
    },

    // Effective zoom-out minimum for the active track, in DISPLAYED-percentage units.
    effectiveZoomOutMin() {
      return this.isTrainerContext ? zoom.trainerOut : zoom.out; // 80 trainer, 100 student
    },

    zoomCursor() {
      return trigger => {
        const bound = trigger === 'out' ? this.effectiveZoomOutMin : zoom.in;
        return bound === this.zoomPercent ? 'zoom-disabled' : '';
      };
    },

    zoomIcon() {
      return trigger => {
        const bound = trigger === 'out' ? this.effectiveZoomOutMin : zoom.in;
        const attribute = bound === this.zoomPercent ? 'disabled' : 'light';
        return require(`@/assets/img/zoom_${trigger}_${attribute}.svg`);
      };
    },

    zoomPercent() {
      // Adjust PDF HTML Zoom (0.9 - 1.5) to default zoom percentage values.
      // Linear mapping display% = scale * 200 - 100: 0.9 -> 80, 1.0 -> 100, 1.5 -> 200.
      if (this.showPDFHtml) {
        const adjustedZoomVal = this.pdfHtmlZoom * 200 - 100;
        return Math.round(adjustedZoomVal);
      }
      return this.isDiscoveryLesson ? this.htmlZoom : this.pdfZoom;
    }
  },
  methods: {
    ...mapMutations('material', [
      'pdfZoomIn',
      'pdfZoomOut',
      'htmlZoomIn',
      'htmlZoomOut',
      'pdfHtmlZoomIn',
      'pdfHtmlZoomOut'
    ]),

    zoomIn() {
      return this.isDiscoveryLesson
        ? this.htmlZoomIn()
        : this.showPDFHtml
        ? this.pdfHtmlZoomIn()
        : this.pdfZoomIn();
    },

    zoomOut() {
      const percentMin = this.effectiveZoomOutMin; // 80 or 100
      const pdfHtmlMin = this.isTrainerContext ? zoom.pdfHtmlTrainerOut : zoom.pdfHtmlStudentOut; // scale equivalent
      return this.isDiscoveryLesson
        ? this.htmlZoomOut(percentMin)
        : this.showPDFHtml
        ? this.pdfHtmlZoomOut(pdfHtmlMin)
        : this.pdfZoomOut(percentMin);
    }
  }
};
</script>

<style scoped src="@/assets/css/pc/material_controls.css"></style>
<style scoped>
@media screen and (max-width: 959px) {
  .zoom-wrapper {
    display: none;
  }
}
</style>
